// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dKka","delete":"styles_delete__w4LKs","update":"styles_update__1YQE_","add":"styles_add__3SJlK"};